import { Ellipsis } from "@visiblethread/react-components";

import ActionsCell from "./components/ActionsCell";
import CategoriesCell from "./components/CategoriesCell";
import NameCell from "./components/NameCell";
import classes from "./WatchwordsTable.module.scss";

export const defaultColumns = [
  {
    header: "Name",
    accessorKey: "name",
    pin: "left",
    size: 180,
    cell: ({ row }) => <NameCell row={row} />,
  },
  {
    header: "Categories",
    accessorKey: "types",
    size: 180,
    cell: ({ getValue }) => <CategoriesCell categoryTypes={getValue()} />,
  },
  {
    header: "Description",
    accessorKey: "description",
    cell: ({ getValue }) => (
      <Ellipsis classes={classes.description} text={getValue()} />
    ),
  },
];

export default [
  ...defaultColumns,
  {
    header: "",
    id: "actions",
    pin: "right",
    enableSorting: false,
    enableResizing: false,
    meta: {
      flexGrow: 1,
    },
    size: 100,
    cell: ({ row }) => <ActionsCell row={row} />,
  },
];
